import e from "../input-group/input-group.js";
//#region components/radio_group/radio_group.vue
var t = {
	compatConfig: { MODE: 3 },
	name: "DtRadioGroup",
	extends: e,
	props: {
		modelValue: {
			type: [String, Number],
			default: ""
		},
		dataQaGroup: {
			type: String,
			default: "radio-group"
		},
		dataQaGroupLegend: {
			type: String,
			default: "radio-group-legend"
		},
		dataQaGroupMessages: {
			type: String,
			default: "radio-group-messages"
		}
	},
	emits: ["input", "update:modelValue"],
	data() {
		return { internalValue: this.modelValue };
	},
	watch: {
		modelValue(e) {
			this.internalValue = e;
		},
		internalValue: {
			immediate: !0,
			handler(e) {
				this.provideObj.selectedValue = e;
			}
		}
	},
	methods: {
		setGroupValue(e) {
			this.$emit("input", e), this.$emit("update:modelValue", e);
		},
		getMessageKey(e, t) {
			return `radio-group-message-${e}-${t}-${this.id}`;
		}
	}
};
//#endregion
export { t as default };

//# sourceMappingURL=radio-group.js.map